module.exports = __webpack_public_path__ + "static/MessageBird-45f551b3f5aa8c659a03696631f1b997.jpg";